import { AgencyTableData } from '../types';

export const removeAllZeroRows = (data: AgencyTableData): AgencyTableData =>
  data.filter(item =>
    Object.values(item.assignmentCounts).some(value => value !== 0),
  );
